import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>/ career</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2021 - present"
            iconStyle={{ background: '#363f9f', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Principal Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Help at Home</h4>
            <p>
            IT Infrastructure Leader with extensive experience in cloud migrations, agile methodologies, endpoint management, and network optimization. Led a successful Azure Cloud migration, implemented Microsoft Intune to strengthen endpoint security, deployed Cato SD-WAN to enhance network performance, and designed comprehensive security controls to ensure compliance and mitigate risks. Proven ability to deliver scalable, cost-efficient, and secure solutions across enterprise environments.
            <br/>Recently focused on modernizing the security technology stack by developing a real-time, enterprise-wide security dashboard. Designed and built an API-driven data pipeline that integrates multiple data sources into a unified data model, providing leadership with instant access to key metrics and equipping the security response team with a centralized view of organizational endpoints and their installed services. This innovation will significantly improve efficiency, response time, and decision-making.

            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2016 - 2021"
            iconStyle={{ background: '#363f9f', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">IT Principal Senior Manager</h3>
            <h4 className="vertical-timeline-element-subtitle">CIGNA</h4>
            <p>
            Full Stack Security Platform Architect with expertise in designing and developing scalable, real-time security analytics solutions. Led the creation of a unified, enterprise-wide security dashboard, integrating over 30 data sources into a centralized warehouse and automating real-time reporting aligned with NIST-800. Modernized security data infrastructure using Docker, Node.js, and React, while collaborating with cross-functional teams to optimize system efficiency. Skilled in creating visualizations for senior leadership, providing industry insights, and driving technology adoption through workshops and training.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2014 - 2016"
            iconStyle={{ background: '#363f9f', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Senior Security Architect</h3>
            <h4 className="vertical-timeline-element-subtitle">T-Mobile</h4>
            <p>
            Enterprise Infrastructure Specialist with expertise in Symantec DLP implementation and enhancement. Led the upgrade to Symantec DLP 12.5, integrating advanced monitoring and proactive threat management. Strengthened data loss prevention policies through audits and recommendations, improving program efficiency and accuracy. Skilled in training teams on DLP best practices, increasing compliance and expertise across the organization.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2010 - 2014"
            iconStyle={{ background: '#363f9f', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Information Protection Manager</h3>
            <h4 className="vertical-timeline-element-subtitle">CIGNA</h4>
            <p>
            Endpoint Security Operations Manager with expertise in large-scale migrations and incident response. Led the global migration of 35,000 endpoint agents from Digital Guardian to Symantec DLP and architected the transition of Symantec DLP infrastructure from Windows to Redhat Linux, enhancing database performance and stability. Executed seamless endpoint version upgrades and conducted forensic analysis to investigate and mitigate security breaches. Proficient in using advanced security tools to identify vulnerabilities and drive proactive risk management strategies.
            </p>
          </VerticalTimelineElement>
          
         <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2008 - 2010"
            iconStyle={{ background: '#363f9f', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">.NET Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Laurin Publishing Company</h4>
            <p>
            IT Educator and Systems Architect with a focus on fostering innovation and strengthening security. Delivered training on development methodologies, enhancing team proficiency and fostering a culture of continuous improvement. Analyzed and improved system architecture, addressing security vulnerabilities to optimize operational performance. Designed and implemented .NET-based internal applications, driving business efficiency through innovative solutions.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2000 - 2007"
            iconStyle={{ background: '#363f9f', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full Stack Systems Analyst</h3>
            <h4 className="vertical-timeline-element-subtitle">Crane & Co. Inc.</h4>
            <p>
            Intranet Applications Developer and Strategic Analyst with a focus on innovation, automation, and market expansion. Led the development of real-time data-driven applications to improve decision-making and operational efficiency. Automated key processes, including email systems for online advertising and data extraction for marketing campaigns. Conducted competitive analyses for strategic positioning and contributed to B2C e-commerce site improvements and security enhancements. Collaborated with marketing and sales teams to create interactive resources that expanded brand reach and market presence.
          </p>
          </VerticalTimelineElement>


          </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;